export var CanonicalMeshType;
(function (CanonicalMeshType) {
    CanonicalMeshType[CanonicalMeshType["BUFFER_GEOMETRY"] = 0] = "BUFFER_GEOMETRY";
})(CanonicalMeshType || (CanonicalMeshType = {}));
